/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.controllers', [])

.controller('PassesController', ['$scope', function($scope) {

    $scope.passes = {

      model: "Your spankin new application.passes.default view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.passes.init();

}]);